import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Aboutus from './views/aboutus'
import Landing from './views/landing'
import LandingPage from './views/landing-page'
import East from './views/east'
import Tours from './views/tours'
import './style.css'

Vue.use(Router)
Vue.use(Meta)
export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'About us',
      path: '/aboutus',
      component: Aboutus,
    },
    {
      name: 'landing',
      path: '/',
      component: Landing,
    },
    {
      name: 'Landing Page',
      path: '/landing-page',
      component: LandingPage,
    },
    {
      name: 'east',
      path: '/east',
      component: East,
    },
    {
      name: 'Tours',
      path: '/tours',
      component: Tours,
    },
  ],
})
